import React from 'react';
import styled from '@emotion/styled';
import colours from '~/utils/colours';

export const defaultColor = colours.greyDarkAlt7;

export interface LabelProps extends React.ComponentPropsWithoutRef<'label'> {
  text: string;
  color?: string;
}

const LabelComponent = styled.label<Omit<LabelProps, 'text'>>`
  display: block;
  font-weight: normal;
  color: ${(props) => props.color};
  margin-bottom: 12px;
`;

const Label = ({ text, color = defaultColor, ...rest }: LabelProps) => (
  <LabelComponent color={color} {...rest}>
    {text}
  </LabelComponent>
);

export default Label;
